import gql from 'graphql-tag';

// Add Mutations

export const ADD_PLATES_BLACKLIST = gql`
  mutation AddBlacklist($blacklistInput: BlacklistInput!) {
    addBlacklist(blacklistInput: $blacklistInput)
  }
`;

export const ADD_MALL = gql`
  mutation AddMall($mallInput: MallInput!) {
    addMall(mallInput: $mallInput)
  }
`;

export const ADD_MALL_ACCESS = gql`
  mutation AddMallAccess($mallAccessInput: MallAccessInput!) {
    addMallAccess(mallAccessInput: $mallAccessInput)
  }
`;

export const ADD_SERVICE_CONFIG = gql`
  mutation AddLprConfig($addLprConfigInput: LprConfigInput!) {
    addLprConfig(addLprConfigInput: $addLprConfigInput)
  }
`;

export const ADD_MOTIVES = gql`
  mutation AddMotive($motiveInput: MotiveInput!) {
    addMotive(motiveInput: $motiveInput)
  }
`;

export const ADD_CAMERA = gql`
  mutation AddCamera($cameraInput: CameraInput!) {
    addCamera(cameraInput: $cameraInput)
  }
`;

export const ADD_TELEGRAM_GROUPS = gql`
  mutation AddTelegramGroup($telegramInput: TelegramInput!) {
    addTelegramGroup(telegramInput: $telegramInput)
  }
`;

export const ADD_EXCLUSION_RULE = gql`
  mutation AddExclusionRule($exclusionRuleInput: ExclusionRuleInput!) {
    addExclusionRule(exclusionRuleInput: $exclusionRuleInput)
  }
`;

// Update Mutations

export const UPDATE_PLATES_BLACKLIST = gql`
  mutation UpdateBlacklist($editBlacklistInput: EditBlacklistInput!) {
    updateBlacklist(editBlacklistInput: $editBlacklistInput) {
      id
      description
    }
  }
`;

export const UPDATE_MALL = gql`
  mutation UpdateMall($editMallInput: EditMallInput!) {
    updateMall(editMallInput: $editMallInput) {
      id
    }
  }
`;

export const UPDATE_CAMERA = gql`
  mutation UpdateCamera($editCameraInput: EditCameraInput!) {
    updateCamera(editCameraInput: $editCameraInput) {
      id
    }
  }
`;

export const UPDATE_MALL_ACCESS = gql`
  mutation UpdateMallAccess($editMallAccessInput: EditMallAccessInput!) {
    updateMallAccess(editMallAccessInput: $editMallAccessInput) {
      id
    }
  }
`;

export const UPDATE_SERVICE_CONFIG = gql`
  mutation UpdateLprConfig($editLprConfigInput: EditLprConfigInput!) {
    updateLprConfig(editLprConfigInput: $editLprConfigInput) {
      id
    }
  }
`;

export const UPDATE_MOTIVE = gql`
  mutation UpdateMotive($editMotiveInput: EditMotiveInput!) {
    updateMotive(editMotiveInput: $editMotiveInput) {
      id
    }
  }
`;

export const UPDATE_TELEGRAM_GROUPS = gql`
  mutation UpdateTelegramGroup($editTelegramInput: EditTelegramInput!) {
    updateTelegramGroup(editTelegramInput: $editTelegramInput) {
      id
    }
  }
`;

export const UPDATE_EXCLUSION_RULE = gql`
  mutation UpdateExclusionRule(
    $editExclusionRuleInput: EditExclusionRuleInput!
  ) {
    updateExclusionRule(editExclusionRuleInput: $editExclusionRuleInput) {
      id
    }
  }
`;

// Delete Mutations

export const DELETE_EXCLUSION_RULES = gql`
  mutation DeleteExclusionRules($id: ID!) {
    deleteExclusionRule(id: $id)
  }
`;

export const DELETE_PLATES_BLACKLIST = gql`
  mutation DeleteBlacklist($id: ID!) {
    deleteBlacklist(id: $id)
  }
`;

export const DELETE_CAMERA = gql`
  mutation DeleteCamera($id: ID!) {
    deleteCamera(id: $id)
  }
`;

export const DELETE_MALL = gql`
  mutation DeleteMall($id: ID!) {
    deleteMall(id: $id)
  }
`;

export const DELETE_MALL_ACCESS = gql`
  mutation DeleteMallAccess($id: ID!) {
    deleteMallAccess(id: $id)
  }
`;

export const DELETE_SERVICE_CONFIG = gql`
  mutation DeleteLprConfig($id: ID!) {
    deleteLprConfig(id: $id)
  }
`;

export const DELETE_MOTIVE = gql`
  mutation DeleteMotive($id: ID!) {
    deleteMotive(id: $id)
  }
`;

export const DELETE_TELEGRAM_GROUPS = gql`
  mutation DeleteTelegramGroup($id: ID!) {
    deleteTelegramGroup(id: $id)
  }
`;
